module.exports = __webpack_public_path__ + "img/design-banner.3ea6c66a.png";